export default __webpack_public_path__ + "static/404-eff29ad0e9b9dda4f61dcff9baedef70.svg";